import { render } from "./cancelOrder.vue?vue&type=template&id=f596064e&ts=true"
import script from "./cancelOrder.vue?vue&type=script&lang=ts"
export * from "./cancelOrder.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__